import React, { forwardRef, Ref } from 'react';
import { SimpleIconProps } from '../icon.types';
import Icon from './Icon';

const svg = `<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none">
  <path d="M3 12h.01"/>
  <path d="M3 18h.01"/>
  <path d="M3 6h.01"/>
  <path d="M8 12h13"/>
  <path d="M8 18h13"/>
  <path d="M8 6h13"/>
</svg>`;

const List = forwardRef(
  (props: SimpleIconProps, ref: Ref<SVGSVGElement> | undefined) => (
    <Icon ref={ref} name='list' svg={svg} {...props} />
  )
);

List.displayName = 'ListIcon';

export default List;
